import * as moment from 'moment';

export class Pago {
	id: number;
	idEmpresa: number;
	cantidad: number;
	cupo: number;
	idTramite: number;
	usuario: string;
	fecha: Date;
	fechaPago: Date;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.idEmpresa = data.idEmpresa;
			this.idTramite = data.idTramite;
			this.cantidad = data.cantidad;
			this.cupo = data.cupo;
			this.usuario = data.usuario;
			this.fecha = new Date(
				moment(data.fecha)
					.utc(true)
					.format('YYYY-MM-DD[T]HH:mm:ss')
			);
			this.fechaPago = new Date(
				moment(data.fechaPago)
					.utc(true)
					.format('YYYY-MM-DD[T]HH:mm:ss')
			);
		}
	}
}
